// src\components\ContactSection\index.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ContactForm from '../ContactFrom/ContactForm';

const ContactSection2 = (props) => {
    const { t } = useTranslation();
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };

    return (
        <div>
            <div className="contact pt-85 pb-120">
                <div className="container">
                    <div className="row mt-none-30">
                        <div className="col-lg-8">
                            <div className="cs-contact-wrap cs-contact-form cd-contact-form item-contact_form">
                                <h3 className="xb-item--title">{t('contact.sendMessage')}</h3>
                                <ContactForm />
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="item-contact_info">
                                <div className="orbx-item--inner">
                                    <div className="orbx-item--top">
                                        <h3 className="orbx-item--title">{t('contact.contactInfo')}</h3>
                                        <ul className="orbx-contact-list list-unstyled pt-20">
                                            <li><a href="tel:+995555275685" style={{color: '#fff'}}><i className="fas fa-phone"></i> +(995) 555 275 685</a></li>
                                            <li><a href="tel:+995557253275" style={{color: '#fff'}}><i className="fas fa-phone"></i> +(995) 557 253 275</a></li>
                                            <li><a href="mailto:info@orbitronix.ge" style={{color: '#fff'}}><i className="fas fa-envelope"></i> info@orbitronix.ge</a></li>
                                        </ul>
                                        
                                        <h3 className="orbx-title pt-50">{t('contact.socials')}</h3>

                                        <ul className="social_icons_block list-unstyled ul_li pb-10">
                                            <li>
                                                <Link onClick={ClickHandler} to="https://www.facebook.com/orbitronixge" aria-label={t('contact.facebook')}>
                                                    <i className="fab fa-facebook-f"></i>
                                                </Link>
                                            </li>
                                            <li>
                                                <Link onClick={ClickHandler} to="https://www.linkedin.com/company/orbitronixge/" aria-label={t('contact.linkedin')}>
                                                    <i className="fab fa-linkedin-in"></i>
                                                </Link>
                                            </li>
                                            <li>
                                                <Link onClick={ClickHandler} to="https://www.instagram.com/orbitronixge" aria-label={t('contact.instagram')}>
                                                    <i className="fab fa-instagram"></i>
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="contact-info_widget">
                                        <h3 className="orbx-title pb-20 pt-20">{t('contact.centralOffice')}</h3>
                                        <span className="orbx-location"><i className="fas fa-building"></i> {t('contact.address')}</span>
                                    </div>
                                    
                                    <hr className="breack-line" />
                                    <div className="contact-info_widget">
                                        <h3 className="orbx-title pb-20">{t('contact.serviceHours')}</h3>
                                        <span className="orbx-location" style={{ lineHeight: '2.2' }} dangerouslySetInnerHTML={{ __html: t('contact.serviceHoursText') }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactSection2;